import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useSelector } from 'react-redux';

const DAYS = [
    { key: 1, label: 'Lundi',    short: 'Lun' },
    { key: 2, label: 'Mardi',    short: 'Mar' },
    { key: 3, label: 'Mercredi', short: 'Mer' },
    { key: 4, label: 'Jeudi',    short: 'Jeu' },
    { key: 5, label: 'Vendredi', short: 'Ven' },
    { key: 6, label: 'Samedi',   short: 'Sam' },
];

const USERS = [
    { key: 'contactPercent',  name: 'Nour',    color: '#3B82F6', light: '#EFF6FF' },
    { key: 'sophiaPercent',   name: 'Sophia',  color: '#8B5CF6', light: '#F5F3FF' },
    { key: 'camillePercent',  name: 'Camille', color: '#EC4899', light: '#FDF2F8' },
];

const DayPanel = ({ config, onChange, onMaxLeads }) => {
    const totalPct = Math.round(USERS.reduce((s, u) => s + (config[u.key] || 0), 0) * 100);
    const isValid = totalPct === 100 || totalPct === 0;

    const handleInput = (key, raw) => {
        const num = Math.min(100, Math.max(0, parseInt(raw) || 0));
        onChange(config.dayOfWeek, key, num / 100);
    };

    return (
        <div style={{ padding: '24px 0' }}>
            {/* Total indicator */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
                <span style={{ fontSize: 13, color: '#6B7280' }}>
                    Total assigné
                </span>
                <span style={{
                    fontSize: 13, fontWeight: 700,
                    padding: '4px 14px', borderRadius: 20,
                    backgroundColor: isValid ? '#F0FDF4' : '#FEF2F2',
                    color: isValid ? '#166534' : '#991B1B',
                    border: `1px solid ${isValid ? '#BBF7D0' : '#FECACA'}`,
                }}>
                    {isValid
                        ? (totalPct === 0 ? 'Aucune assignation' : `${totalPct}% ✓`)
                        : `${totalPct}% — doit être 100%`
                    }
                </span>
            </div>

            {/* User rows */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 28 }}>
                {USERS.map((u) => {
                    const val = Math.round((config[u.key] || 0) * 100);
                    return (
                        <div key={u.key} style={{
                            backgroundColor: val > 0 ? u.light : '#FAFAFA',
                            border: `1px solid ${val > 0 ? u.color + '30' : '#F3F4F6'}`,
                            borderRadius: 10,
                            padding: '14px 16px',
                            transition: 'background 0.2s',
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <div style={{
                                        width: 8, height: 8, borderRadius: '50%',
                                        backgroundColor: val > 0 ? u.color : '#D1D5DB',
                                        flexShrink: 0,
                                    }} />
                                    <span style={{ fontWeight: 600, fontSize: 14, color: '#111827' }}>{u.name}</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                    <input
                                        type="number"
                                        min={0}
                                        max={100}
                                        value={val}
                                        onChange={(e) => handleInput(u.key, e.target.value)}
                                        style={{
                                            width: 64,
                                            textAlign: 'center',
                                            fontWeight: 700,
                                            fontSize: 15,
                                            color: val > 0 ? u.color : '#6B7280',
                                            border: `1px solid ${val > 0 ? u.color + '50' : '#D1D5DB'}`,
                                            borderRadius: 8,
                                            padding: '5px 4px',
                                            outline: 'none',
                                            backgroundColor: '#fff',
                                        }}
                                    />
                                    <span style={{ fontSize: 14, color: '#9CA3AF', fontWeight: 500 }}>%</span>
                                </div>
                            </div>
                            <input
                                type="range"
                                min={0}
                                max={100}
                                step={5}
                                value={val}
                                onChange={(e) => onChange(config.dayOfWeek, u.key, parseInt(e.target.value) / 100)}
                                style={{ width: '100%', accentColor: u.color, cursor: 'pointer', height: 6 }}
                            />
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 4 }}>
                                <span style={{ fontSize: 11, color: '#D1D5DB' }}>0%</span>
                                <span style={{ fontSize: 11, color: '#D1D5DB' }}>50%</span>
                                <span style={{ fontSize: 11, color: '#D1D5DB' }}>100%</span>
                            </div>
                        </div>
                    );
                })}
            </div>

            {/* Max leads */}
            <div style={{
                marginTop: 32,
                paddingTop: 20,
                borderTop: '1px solid #F3F4F6',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
            }}>
                <div>
                    <div style={{ fontSize: 14, fontWeight: 600, color: '#111827', display: 'flex', alignItems: 'center', gap: 6 }}>
                        <i className="bi bi-people"></i>
                        Max leads / utilisateur
                    </div>
                    <div style={{ fontSize: 12, color: '#9CA3AF', marginTop: 2 }}>
                        Nombre maximum de leads assignés par personne
                    </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <button
                        onClick={() => onMaxLeads(config.dayOfWeek, Math.max(0, config.maxLeadsPerUser - 5))}
                        style={{
                            width: 36, height: 36, borderRadius: 8,
                            border: '1px solid #D1D5DB', backgroundColor: '#fff',
                            cursor: 'pointer', fontWeight: 700, color: '#374151', fontSize: 20,
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}
                    >−</button>
                    <input
                        type="number"
                        min={0}
                        value={config.maxLeadsPerUser}
                        onChange={(e) => onMaxLeads(config.dayOfWeek, Math.max(0, parseInt(e.target.value) || 0))}
                        style={{
                            width: 60, textAlign: 'center', fontWeight: 700,
                            fontSize: 15, color: '#111827',
                            border: '1px solid #D1D5DB', borderRadius: 8,
                            padding: '5px 0', outline: 'none',
                        }}
                    />
                    <button
                        onClick={() => onMaxLeads(config.dayOfWeek, config.maxLeadsPerUser + 5)}
                        style={{
                            width: 36, height: 36, borderRadius: 8,
                            border: '1px solid #D1D5DB', backgroundColor: '#fff',
                            cursor: 'pointer', fontWeight: 700, color: '#374151', fontSize: 20,
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                        }}
                    >+</button>
                </div>
            </div>
        </div>
    );
};

const LeadConfigPage = () => {
    const apiKey = useSelector((state) => state.auth.token);
    const navigate = useNavigate();
    const [configs, setConfigs] = useState([]);
    const [activeDay, setActiveDay] = useState(1);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [saved, setSaved] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_BACKEND_EVENT}/hubspot/lead-config`, {
                headers: { Authorization: `Bearer ${apiKey}` },
            })
            .then((res) => { setConfigs(res.data); setLoading(false); })
            .catch(() => { setError('Erreur lors du chargement.'); setLoading(false); });
    }, [apiKey]);

    const handleChange = (dayOfWeek, field, value) => {
        setConfigs((prev) => prev.map((c) => c.dayOfWeek === dayOfWeek ? { ...c, [field]: value } : c));
        setSaved(false);
        setError('');
    };

    const handleMaxLeads = (dayOfWeek, value) => {
        setConfigs((prev) => prev.map((c) => c.dayOfWeek === dayOfWeek ? { ...c, maxLeadsPerUser: value } : c));
        setSaved(false);
        setError('');
    };

    const validate = () => {
        for (const c of configs.filter((c) => c.dayOfWeek !== 0)) {
            const total = USERS.reduce((s, u) => s + (c[u.key] || 0), 0);
            if (Math.abs(total - 1) > 0.011 && total !== 0) {
                const day = DAYS.find((d) => d.key === c.dayOfWeek);
                return `${day?.label} : total = ${Math.round(total * 100)}% (doit être 100%)`;
            }
        }
        return null;
    };

    const handleSave = async () => {
        const err = validate();
        if (err) { setError(err); return; }
        setSaving(true);
        setError('');
        try {
            await axios.put(
                `${process.env.REACT_APP_BACKEND_EVENT}/hubspot/lead-config`,
                configs,
                { headers: { Authorization: `Bearer ${apiKey}` } }
            );
            setSaved(true);
            setTimeout(() => setSaved(false), 3000);
        } catch {
            setError('Erreur lors de la sauvegarde.');
        } finally {
            setSaving(false);
        }
    };

    const activeConfig = configs.find((c) => c.dayOfWeek === activeDay);

    const getDayTotal = (dayKey) => {
        const c = configs.find((cfg) => cfg.dayOfWeek === dayKey);
        if (!c) return null;
        return Math.round(USERS.reduce((s, u) => s + (c[u.key] || 0), 0) * 100);
    };

    if (loading) return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '80vh', flexDirection: 'column', gap: 12 }}>
            <div className="spinner-border" role="status" style={{ color: '#374151' }} />
            <span style={{ color: '#6B7280', fontSize: 14 }}>Chargement...</span>
        </div>
    );

    return (
        <div style={{ minHeight: '100vh', backgroundColor: '#F9FAFB' }}>
            {/* Header */}
            <div style={{
                backgroundColor: '#fff',
                borderBottom: '1px solid #E5E7EB',
                padding: '12px 16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                position: 'sticky',
                top: 0,
                zIndex: 10,
                boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                gap: 12,
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <button
                        onClick={() => navigate('/')}
                        style={{
                            background: 'none', border: '1px solid #E5E7EB',
                            borderRadius: 8, padding: '6px 12px',
                            cursor: 'pointer', color: '#374151', fontSize: 13, fontWeight: 500,
                            display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0,
                        }}
                    >
                        <i className="bi bi-arrow-left"></i>
                        <span className="d-none d-sm-inline">Retour</span>
                    </button>
                    <div>
                        <div style={{ fontWeight: 700, fontSize: 15, color: '#111827' }}>
                            Lead Assignement
                        </div>
                        <div style={{ fontSize: 11, color: '#9CA3AF' }} className="d-none d-sm-block">
                            Distribution des leads par jour
                        </div>
                    </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
                    {saved && (
                        <span style={{ color: '#166534', fontSize: 13, fontWeight: 500, display: 'flex', alignItems: 'center', gap: 4 }}>
                            <i className="bi bi-check-circle-fill"></i>
                            <span className="d-none d-sm-inline">Sauvegardé</span>
                        </span>
                    )}
                    <button
                        onClick={handleSave}
                        disabled={saving}
                        style={{
                            backgroundColor: saving ? '#A5B4FC' : '#6366F1',
                            color: '#fff', border: 'none', borderRadius: 8,
                            padding: '8px 16px', fontWeight: 600, fontSize: 14,
                            cursor: saving ? 'not-allowed' : 'pointer',
                            display: 'flex', alignItems: 'center', gap: 8, whiteSpace: 'nowrap',
                        }}
                    >
                        {saving
                            ? <><span className="spinner-border spinner-border-sm" role="status" /> Sauvegarde...</>
                            : <><i className="bi bi-cloud-upload"></i> Sauvegarder</>
                        }
                    </button>
                </div>
            </div>

            {/* Error */}
            {error && (
                <div style={{
                    margin: '12px 16px 0',
                    padding: '10px 14px',
                    backgroundColor: '#FEF2F2',
                    border: '1px solid #FECACA',
                    borderRadius: 8,
                    color: '#991B1B',
                    fontSize: 13,
                    display: 'flex', alignItems: 'center', gap: 8,
                }}>
                    <i className="bi bi-exclamation-circle-fill"></i> {error}
                </div>
            )}

            {/* Tab card */}
            <div style={{ padding: 16 }}>
                <div style={{
                    backgroundColor: '#fff',
                    border: '1px solid #E5E7EB',
                    borderRadius: 12,
                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                    overflow: 'hidden',
                }}>
                    {/* Tabs */}
                    <div style={{
                        display: 'flex',
                        borderBottom: '1px solid #E5E7EB',
                        overflowX: 'auto',
                        scrollbarWidth: 'none',
                    }}>
                        {DAYS.map((day) => {
                            const total = getDayTotal(day.key);
                            const isActive = activeDay === day.key;
                            const totalOk = total === 100 || total === 0;
                            return (
                                <button
                                    key={day.key}
                                    onClick={() => setActiveDay(day.key)}
                                    style={{
                                        flex: 1,
                                        minWidth: 56,
                                        padding: '12px 8px',
                                        border: 'none',
                                        borderBottom: isActive ? '2px solid #6366F1' : '2px solid transparent',
                                        backgroundColor: isActive ? '#fff' : '#FAFAFA',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        gap: 4,
                                        transition: 'background 0.15s',
                                    }}
                                >
                                    <span style={{
                                        fontSize: 13,
                                        fontWeight: isActive ? 700 : 500,
                                        color: isActive ? '#6366F1' : '#6B7280',
                                    }}>
                                        {day.short}
                                    </span>
                                    {total !== null && (
                                        <span style={{
                                            fontSize: 10,
                                            fontWeight: 600,
                                            color: totalOk ? '#166534' : '#991B1B',
                                        }}>
                                            {total}%
                                        </span>
                                    )}
                                </button>
                            );
                        })}
                    </div>

                    {/* Panel */}
                    <div style={{ padding: '0 24px 24px' }}>
                        {activeConfig && (
                            <DayPanel
                                config={activeConfig}
                                onChange={handleChange}
                                onMaxLeads={handleMaxLeads}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LeadConfigPage;
